<template>
	<div :class="classObj" class="app-wrapper">
		<template v-if="false">
			<div style="text-align: center">
				<p>Under maintenance</p>
			</div>
		</template>
		<template v-else>
			<div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
			<sidebar class="sidebar-container" />
			<div class="main-container">
				<div :class="{ 'fixed-header': fixedHeader }">
					<navbar />
				</div>
				<app-main />
			</div>
		</template>
	</div>
</template>

<script>
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { mapState } from 'vuex';

export default {
	name: 'Layout',
	components: {
		AppMain,
		Navbar,
		Sidebar
	},
	mixins: [ResizeMixin],
	computed: {
		...mapState({
			refreshKey: state => state.app.refreshKey,
			sidebar: state => state.app.sidebar,
			device: state => state.app.device,
			showSettings: state => state.settings.showSettings,
			needTagsView: state => state.settings.tagsView,
			fixedHeader: state => state.settings.fixedHeader
		}),
		classObj() {
			return {
				hideSidebar: !this.sidebar.opened,
				openSidebar: this.sidebar.opened,
				withoutAnimation: this.sidebar.withoutAnimation,
				mobile: this.device === 'mobile'
			};
		}
	},
	watch: {},
	methods: {
		handleClickOutside() {
			this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
	@include clearfix;
	position: relative;
	height: 100%;
	width: 100%;

	&.mobile.openSidebar {
		position: fixed;
		top: 0;
	}
}

.drawer-bg {
	background: #000;
	opacity: 0.3;
	width: 100%;
	top: 0;
	height: 100%;
	position: absolute;
	z-index: 999;
}

.fixed-header {
	position: fixed;
	top: 0;
	right: 0;
	z-index: 9;
	width: calc(100% - #{$sideBarWidth});
	transition: width 0.28s;
}

.hideSidebar .fixed-header {
	width: calc(100% - 54px);
}

.mobile .fixed-header {
	width: 100%;
}
</style>
